import { createSlice } from "@reduxjs/toolkit";
import { appStorageKey, tenant } from "../utils/global";



const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

const getStoredBranch = () => {
    const storedBranch = safeParse(localStorage.getItem(appStorageKey('selectedBranch')));
    if (storedBranch?.value) {
        return storedBranch;
    }
    return {
        name: tenant()?.companies[0].branches[0]?.name[0].text || 'Select a Branch',
        value: tenant()?.companies[0].branches[0]?._id,
    };
};

const initialState = getStoredBranch();

const currentBranchSlice = createSlice({
    name: 'currentBranch',
    initialState,
    reducers: {
        setCurrentBranch:(state,action)=> {
            state.name = action.payload.name;
            state.value = action.payload.value;
            state.updatedAt = Date.now();
            localStorage.setItem(appStorageKey('selectedBranch'), JSON.stringify({
                name: action.payload.name,
                value: action.payload.value,
                updatedAt: state.updatedAt
            }));
        }
    }
});

export const {setCurrentBranch} = currentBranchSlice.actions;
export default currentBranchSlice.reducer
